import { Flex } from '@chakra-ui/react';
import { Alert, AlertDescription, Button } from '@/components/v4';
import getRuntimeAppConfig from '@/utils/runtimeAppConfig';

const SyncRetirementBanner = ({ onUpgrade }) => {
    const retirementDate =
        getRuntimeAppConfig().legacySyncRetirementDate ?? 'Jul 30, 2026';

    return (
        <Alert
            status="warning"
            variant="left-accent"
            justifyContent="space-between"
            mb={4}>
            <AlertDescription flex={1}>
                <Flex as="span" wrap="wrap" gap={1} alignItems="center">
                    <span>
                        <strong>
                            Legacy Microsoft authentication will no longer be
                            supported after {retirementDate}.
                        </strong>{' '}
                        Upgrade to prevent service delays and avoid disruption.
                    </span>
                </Flex>
            </AlertDescription>
            <Button
                colorScheme="messenger"
                size="sm"
                ml={4}
                flexShrink={0}
                onClick={onUpgrade}>
                Upgrade now
            </Button>
        </Alert>
    );
};

export default SyncRetirementBanner;
